<template>
    <teleport to="#modal">
        <Loading :visible="loading">
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">

            <div class="py-10 flex justify-between items-center">
                <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
                <div class="flex">
                    <NextButton @click="$router.back()" variant="outline-secondary" class="w-44 text-sm py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                    <NextButton v-if="hasPermission('create fornitori')" component="router-link"
                        :to="{ name: 'NuovoFornitore' }" variant="primary"
                        class="w-44 ml-3 text-sm py-2 px-4 m-0 hidden sm:block">
                        + Aggiungi
                    </NextButton>
                </div>
            </div>
            <div class="flex justify-between items-center">
                <h3 class="text-3xl font-bold">Lista fornitori</h3>
            </div>

            <div class="grid grid-cols-[repeat(5,_minmax(0,_1fr))_max-content] gap-4 mb-3">
                <div class="flex flex-col col-span-2">
                    <Field field_name="Cerca" @update:modelValue="lista_fornitori.debounceSearch"
                        v-model="lista_fornitori.search" placeholder="Cerca"></Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Settore merceologico" placeholder="Settore merceologico">
                        <VueMultiselect :searchable="true" :internal-search="false" :multiple="true" trackBy="id"
                            label="descrizione" @search-change="settore_merceologico_autocomplete.search"
                            v-model="settore_merceologico_autocomplete.selection"
                            :options="settore_merceologico_autocomplete.options" :close-on-select="true"
                            :clear-on-select="true" placeholder="Settore" deselectLabel="Deseleziona"
                            selectedLabel="Selezionato" selectLabel="Seleziona" class="next-vue-multiselect">
                            <template v-slot:tag="{ option, remove }">
                                <MultiselectOption @remove="remove(option)">
                                    {{ option.descrizione }}
                                </MultiselectOption>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col">
                    <Field field_name="Qualifica">
                        <VueMultiselect :searchable="true" :internal-search="false" :multiple="false" trackBy="id"
                            label="text" @search-change="qualifica_autocomplete.search"
                            v-model="qualifica_autocomplete.selection" :options="qualifica_autocomplete.options"
                            :close-on-select="true" :clear-on-select="true" placeholder="Qualifica"
                            deselectLabel="Deseleziona" selectedLabel="Selezionato" selectLabel="Seleziona"
                            class="next-vue-multiselect-single">
                        </VueMultiselect>
                    </Field>
                </div>

                <div class="flex flex-col">
                    <Field field_name="Aziende del gruppo" placeholder="Aziende del gruppo">
                        <VueMultiselect :searchable="true" :internal-search="false" :multiple="true" trackBy="id"
                            label="nome" @search-change="aziende_gruppo.search" v-model="aziende_gruppo.selection"
                            :options="aziende_gruppo.options" :close-on-select="true" :clear-on-select="true"
                            placeholder="Azienda" deselectLabel="Deseleziona" selectedLabel="Selezionato"
                            selectLabel="Seleziona" class="next-vue-multiselect">
                            <template v-slot:tag="{ option, remove }">
                                <MultiselectOption @remove="remove(option)">
                                    {{ option.nome }}
                                </MultiselectOption>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex items-end">
                    <NextButton @click="download" :disabled="loading_download" variant="secondary"
                        class="flex justify-center items-center w-32 px-3 h-[40px]">
                        <Spinner v-if="loading_download" class="w-4 h-4"></Spinner>
                        <span v-else>Download</span>
                    </NextButton>
                </div>
                <p v-if="generatingFile" class="text-next-bri col-span-6 text-right">
                    Il file è in generazione, attendi il
                    completamento e scaricalo nella
                    <RouterLink :to="{ name: 'DownloadCenter' }" target="_blank" class="underline">sezione download.
                    </RouterLink>
                </p>

            </div>

            <div class="flex justify-between">
                <Switcher v-model="tabIndex" :options="['lista', 'Mappa']" class="grow whitespace-nowrap mr-3">
                </Switcher>
                <Paginator :pagination="lista_fornitori.paginate"></Paginator>
            </div>

            <div v-show="tabIndex == 1" class="pt-4">
                <div ref="map" style="height: 700px"></div>
            </div>

            <div v-show="tabIndex == 0">
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed"
                        v-model:cols="fornitoriCols" :rows="lista_fornitori.rows"
                        @order-update="lista_fornitori.updateCols">
                        <template v-for="(c, j) in lista_fornitori.rows" :key="j" v-slot:[`td_${j}_4`]>
                            <TableTooltip inner_class="relative">
                                <MultiselectOption v-for="(option, i) in c.settori" :key="i" readonly="true">
                                    {{ option }}
                                </MultiselectOption>
                            </TableTooltip>
                        </template>
                        <template v-for="(c, j) in lista_fornitori.rows" :key="j" v-slot:[`td_${j}_1`]>
                            {{ c.accordo_quadro ? 'Sì' : 'No' }}
                        </template>
                        <!--                    <template v-for="(c, j) in lista_fornitori.rows" :key="j" v-slot:[`td_${j}_6`]>-->
                        <!--                        <TabellaContextMenu-->
                        <!--                            menuClass="shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"-->
                        <!--                            buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"-->
                        <!--                            :context="c"-->
                        <!--                            :id="j"-->
                        <!--                            teleport_to="#modal"-->
                        <!--                            :cmOpener="cmOpener"-->
                        <!--                        >-->
                        <!--                            <router-link to="#" class="hover:text-next-neu mb-2">Attività</router-link>-->
                        <!--                            <router-link to="#" class="hover:text-next-neu mb-2">Contatti</router-link>-->
                        <!--                        </TabellaContextMenu>-->
                        <!--                    </template>-->
                        <template v-for="(c, j) in lista_fornitori.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                            {{ QualificheFornitore[c.qualifica].replace('_', ' ') }}
                        </template>
                        <template v-for="(c, j) in lista_fornitori.rows" :key="j" v-slot:[`td_${j}_6`]="context">
                            <router-link :to="{ name: 'DettaglioFornitore', params: { fid: context.context.row.id } }"
                                class="text-center inset-0 absolute flex items-center justify-center">
                                <i class="icon-chevron_destra"></i>
                            </router-link>
                        </template>
                    </NextTable>

                </div>
                <InfiniteLoading @infinite="lista_fornitori.fetchNextPage"
                    :identifier="lista_fornitori.infiniteIdentifier" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri fornitori.</div>
                    </template>
                </InfiniteLoading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue, setup } from 'vue-class-component';
import AlertCard from "../components/AlertCard.vue";
import NextTable from "@/components/NextTable.vue";
import Paginator from "@/components/Paginator.vue";
import InfiniteLoading from "v3-infinite-loading";
import ConfermaModal from "@/components/ConfermaModal.vue";
import ContextMenu from "@/components/ContextMenu.vue";
import Loading from "@/components/Loading.vue";
import TopbarProgetti from "@/components/TopbarProgetti.vue";
import Switcher from "@/components/Switcher.vue";
import NextButton from "@/components/NextButton.vue";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import fornitoriManager from "../api/FornitoriManager";
import gMapLoader, { Paths, QualificheFornitore, TableOrder } from "@/types";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import qualificheManager from "../api/QualificaManager";
import Field from "@/components/Field.vue";
import Autocomplete from "@/setup/Autocomplete";
import settoriMerceologiciManager from "../api/SettoriMerceologiciManager";
import MultiselectOption from "@/components/MultiselectOption.vue";
import { aziendeGruppoManager } from "../api/AziendeGruppo";
import { Watch } from 'vue-property-decorator/lib/decorators/Watch';
import TableTooltip from "@/components/TableTooltip.vue";
import Lista from '@/setup/ListaCerca';
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import { lista_clienti, lista_fornitori } from "@/BreadcrumbsPath";
import Spinner from "@/components/Spinner.vue";
import Tabs from "@/components/Tabs.vue";
import { v4 as uuidv4 } from 'uuid';
import { mapGetters } from "vuex";

@Options({
    name: 'ListaFornitori',
    computed: {
        QualificheFornitore() {
            return QualificheFornitore
        },
        ...mapGetters([
            'hasPermission',
            'me',
        ])
    },
    components: {
        Tabs,
        Spinner,
        Breadcrumbs,
        MultiselectOption,
        Field,
        NextButton,
        Switcher,
        TopbarProgetti,
        AlertCard,
        NextTable,
        Paginator,
        InfiniteLoading,
        ConfermaModal,
        ContextMenu,
        Loading,
        TabellaContextMenu,
        TableTooltip,
    },
})
export default class ListaFornitori extends Vue {
    hasPermission!: any
    loading = false
    timeout = 0
    aziende_ids = null
    settori_ids = null
    loading_download = false
    cmOpener: any = setup(() => ContextMenuOpener())
    settore_merceologico_autocomplete: any = setup(() => Autocomplete(settoriMerceologiciManager, true))
    aziende_gruppo: any = setup(() => Autocomplete(aziendeGruppoManager, true))
    qualifica_autocomplete: any = setup(() => Autocomplete(qualificheManager, false))

    lista_fornitori: any = setup(() => Lista(fornitoriManager, this.fornitoriCols));
    map!: any
    tabIndex = 0
    generatingFile = false

    markers: any = []

    created() {
        this.qualifica_autocomplete.search('', 0)
    }

    async mounted() {
        this.lista_fornitori.reset()
        //@ts-ignore
        this.settore_merceologico_autocomplete.search()
        //@ts-ignore
        this.aziende_gruppo.search()

        const maps = await gMapLoader.importLibrary("maps");
        const { AdvancedMarkerElement } = await gMapLoader.importLibrary("marker");

        const map = this.$refs.map as HTMLElement;
        this.map = new maps.Map(map, {
            center: { lat: 44, lng: 10 },
            zoom: 10,
            mapId: uuidv4()
        });
    }

    get getBreadcrumbsPath(): Paths[] {
        return lista_fornitori
    }

    @Watch('lista_fornitori.rows', { deep: true })
    async rowUpdate(new_val: number, old_val: number) {
        this.markers.forEach((marker: any) => {
            marker.setMap(null)
        })
        let rest_view = false
        this.markers = []
        const { AdvancedMarkerElement } = await gMapLoader.importLibrary("marker");
        const { LatLngBounds } = await gMapLoader.importLibrary("core");

        const bounds = new LatLngBounds();

        this.lista_fornitori.rows.forEach((row: any) => {
            if (row.lat && row.lng) {
                const marker = new AdvancedMarkerElement({
                    position: { lat: row.lat, lng: row.lng },
                    map: this.map,
                    title: row.denominazione,
                });
                marker.element.addEventListener('click', () => {
                    //@ts-ignore
                    this.$router.push({ name: 'DettaglioFornitore', params: { fid: row.id } })
                })
                bounds.extend(marker.position)
                this.markers.push(marker)
                rest_view = true
            }
        })
        if (rest_view) {
            this.map.fitBounds(bounds);
        }
    }

    @Watch('aziende_gruppo.selection')
    @Watch('settore_merceologico_autocomplete.selection')
    @Watch('qualifica_autocomplete.selection')
    performSearch() {
        //@ts-ignore
        this.lista_fornitori.apiParams.settori = this.settore_merceologico_autocomplete.selection.map(e => e.id)
        //@ts-ignore
        this.lista_fornitori.apiParams.aziende = this.aziende_gruppo.selection.map(e => e.id)
        //@ts-ignore
        this.lista_fornitori.apiParams.qualifica = this.qualifica_autocomplete.selection?.id

        this.lista_fornitori.reset();
    }

    download() {
        this.loading_download = true;
        fornitoriManager
            //@ts-ignore
            .export({
                params:
                {
                    'settori': this.settore_merceologico_autocomplete.selection.map((e: any) => e.id),
                    'aziende': this.aziende_gruppo.selection.map((e: any) => e.id),
                    'qualifica': this.qualifica_autocomplete.selection?.id
                }
            })
            .then(() => {
                this.generatingFile = true;
                setTimeout(() => {
                    this.generatingFile = false;
                }, 5000);
            })
            .finally(() => {
                this.loading_download = false;
            });

        this.loading_download = true;
    }

    fornitoriCols: any[] = [
        {
            name: 'Denominazione',
            prop: 'denominazione',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Accordo quadro',
            prop: 'accordo_quadro',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Email',
            prop: 'email',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Numero di telefono',
            prop: 'telefono_1',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Settore merceologico',
            prop: 'settori',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Qualifica',
            prop: 'qualifica',
            orderable: true,
            class: 'text-left w-36 whitespace-nowrap',
            td_class: 'h-11.5 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
        // {
        //     name: '',
        //     prop: '',
        //     orderable: false,
        //     class: 'min-w-10 w-10 whitespace-nowrap border-r-0',
        //     td_class: 'relative hover:bg-next-orange hover:text-white border-r-0 bg-next-gray-md-dark',
        //     resizable: false
        // }
    ]
}

</script>


<style lang="scss" scoped>
#map {
    z-index: 1;
    height: 600px;
}
</style>
